module.exports = __webpack_public_path__ + "static/media/tona-app-store@3x.ee49078c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/tona-app-store@3x.png
// module id = 760
// module chunks = 2